import React from "react";
import { Nav, NavItem, Label } from "react-bootstrap";
import styled, { css } from "styled-components";
import { formatDateTime } from "../../../utils";
import { LinkContainer } from "react-router-bootstrap";
import truncate from "truncate";
import theme from "../../../theme";

const RightLabel = styled(Label)`
    float: right;
    margin-right: 5px;
`;

const StyledNavItem = styled(NavItem)`
    ${props =>
        props.brown &&
        css`
            a {
                background: ${theme.finishOrderBrown} !important;
                color: white !important;
                &:hover {
                    color: black !important;
                }
            }
        `},
    ${props => 
        props.yellow &&
        css`
            a {
                background: ${theme.customerOrderYellow} !important;
                color: black !important;
                &:hover {
                    color: darkgoldenrod !important;
                }
            }
        `
    },
    ${props => 
        props.lightgreen &&
        css`
            a {
                background: ${theme.customerOrderLightgreen} !important;
                color: black !important;
                &:hover {
                    color: darkgoldenrod !important;
                }
            }
        `
    }
`;

export default class VersionsListContainer extends React.Component {
    render() {
        let versions = this.props.versions
            .slice()
            .reverse()
            .map((v, i) => (
                <LinkContainer key={v._id} to={this.props.makeUrl(i, v._id)} exact>
                    <StyledNavItem title={v.versionMetadata.message} brown={v.versionMetadata.isFinishOrReopen} yellow={v.versionMetadata.message === "Changed official order name by customer" || v.versionMetadata.message === "Customer added order’s photo" || v.versionMetadata.message === "Customer changed order’s photo"} lightgreen={v.versionMetadata.message === "Changed official order name in customer panel view" || v.versionMetadata.message === "Added order’s photo" || v.versionMetadata.message === "Changed order’s photo"}>
                        #{v.versionMetadata.number} {v.versionMetadata.author.displayName}:{" "}
                        {truncate(v.versionMetadata.message, 100)}
                        <RightLabel>{formatDateTime(v.versionMetadata.createdOn)}</RightLabel>
                        {i === 0 && <RightLabel bsStyle="success">LATEST VERSION</RightLabel>}
                    </StyledNavItem>
                </LinkContainer>
            ));
        return (
            <Nav bsStyle="pills" stacked>
                {versions}
            </Nav>
        );
    }
}
